import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const MessageFromTemplateIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M4 6.85714L10.3636 6.85714L10.3636 3L20 12L10.3636 21L10.3636 17.1429L4 17.1429L4 6.85714Z'
                fill='currentColor'
            />
        </>
    ),
})

MessageFromTemplateIcon.displayName = 'MessageFromTemplateIcon'
